import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import LeftBar from "components/Layouts/LeftBar";

import Reports from "components/Reports";
import Masters from "components/Masters";
import Settings from "components/Settings";
import HomeSkeleton from "./HomeSkeleton";

// Masters
import Training from "../Training";
import Designations from "components/Masters/Designations";
import Holidays from "components/Masters/Holidays";
import Employees from "components/Masters/Employees";
import Projects from "components/Masters/Projects";
import Users from "components/Masters/Users";
import GPT from "components/Masters/GPT";
import Price from "components/Masters/Price";
import Scheme from "components/Masters/Scheme";

import LeavePlanner from "components/LeavePlanner";
import LeavePlannerApprove from "components/LeavePlannerApprove";
import LeadProfile from "components/Crm/LeadProfile";
import CrmDashboard from "components/Crm/CrmDashboard";
import ROI from "components/ROI";
import CrmReports from "components/Crm/CrmReports";

import { AUTH_APIs } from "apihandlers/auth";
import { CONFIG, LOCAL_STORAGE } from "common/config";
import { LABELS, TITLES } from "common/lables";

import "./styles/home.css";

const imgBanner = require("assets/images/banner.png");

const HomePage = (props: any) => {
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState<any>({});
  const [page, setPage] = useState(LABELS.HOME);

  const leftBarRef: any = useRef(null);

  useEffect(() => {
    // console.log("Home: userEffect: state: ", loading);
    if (loading) {
      checkLogin();
    }
  }, [loading]);

  const checkLogin = () => {
    const args = {};
    AUTH_APIs.checklogin(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      // console.log("checklogin: ", res);
      if (status === 200) {
        if (response.status) {
          let userInfo = localStorage.getItem(LOCAL_STORAGE.USER_INFO);
          if (userInfo) {
            userInfo = JSON.parse(userInfo);
            setUserInfo(userInfo);
          }
          setLoading(false);
          setPage(LABELS.HOME);
        } else {
          window.open("/login", "_self");
        }
      }
    });
  };

  const reportsRef: any = useRef({});
  const mastersRef: any = useRef({});
  const trainingRef: any = useRef({});

  const onSetPage = (val = "") => {
    console.log("onSetPage", val);
    setPage(val);
  };

  console.log("home: userInfo:", userInfo);

  return (
    <div
      className={"homeContainer " + (page === LABELS.HOME ? "bgBanner" : "")}
      style={{
        overflow: page === LABELS.GANTT_CHART ? "none" : "auto",
      }}
    >
      {loading ? (
        <HomeSkeleton />
      ) : (
        <React.Fragment>
          <LeftBar
            setPage={onSetPage}
            page={page}
            userInfo={userInfo}
            childRef={leftBarRef}
          />
          <div className="content">
            {page === LABELS.HOME && (
              <div>
                <h4
                  className="shadowTxt fontXL"
                  style={{
                    marginTop: 18,
                    textAlign: "left",
                  }}
                >
                  {CONFIG.SITE_NAME}
                  {/* <small className="fontM">{CONFIG.VERSION}</small> */}
                </h4>
                <h4
                  className="shadowTxt fontL"
                  style={{ marginTop: 0, textAlign: "left", paddingTop: 10 }}
                >
                  Welcome {userInfo.role && userInfo.role.name + "..!"}
                </h4>
                {/* <div style={{ width: "80%", margin: "auto" }}>
                  <img src={imgBanner} className="responsive" />
                </div> */}
              </div>
            )}

            {page === LABELS.REPORTS && (
              <Reports childRef={reportsRef} userInfo={userInfo} />
            )}
            {page === LABELS.MASTERS && (
              <Masters childRef={mastersRef} userInfo={userInfo} />
            )}
            {page === LABELS.TRAINING && (
              <Training childRef={trainingRef} userInfo={userInfo} />
            )}
            {page === LABELS.USERS && <Users />}

            {page === LABELS.SETTINGS && <Settings userInfo={userInfo} />}

            {page === LABELS.DESIGNATION_MASTER && (
              <Designations userInfo={userInfo} />
            )}

            {page === LABELS.HOLIDAY_MASTER && <Holidays userInfo={userInfo} />}
            {page === LABELS.EMPLOYEE_MASTER && (
              <Employees userInfo={userInfo} />
            )}
            {page === LABELS.GPT_MASTER && <GPT userInfo={userInfo} />}
            {page === LABELS.PRICE && <Price userInfo={userInfo} />}
            {page === LABELS.SCHEME && <Scheme userInfo={userInfo} />}

            {page === LABELS.PROJECTS && <Projects userInfo={userInfo} />}

            {page === LABELS.LEAVE_PLANNER && (
              <LeavePlanner userInfo={userInfo} />
            )}

            {page === LABELS.LEAVE_PLANNER_APPROVE && (
              <LeavePlannerApprove userInfo={userInfo} />
            )}

            {page === LABELS.LEAD_PROFILE && (
              <LeadProfile
                header={true}
                setDashMenu={(menu) => {
                  setPage(menu);
                  leftBarRef.hideCrmMenu();
                }}
              />
            )}

            {page === TITLES.CRM_DASHBOARD && (
              <CrmDashboard
                setDashMenu={(menu) => {
                  setPage(menu);
                  leftBarRef.hideCrmMenu();
                }}
              />
            )}

            {page === TITLES.ROI && (
              <ROI
                setDashMenu={(menu) => {
                  setPage(menu);
                  leftBarRef.hideCrmMenu();
                }}
              />
            )}

            {page === TITLES.CRM_REPORTS && (
              <CrmReports
                userInfo={userInfo}
                setDashMenu={(menu) => {
                  setPage(menu);
                  leftBarRef.hideCrmMenu();
                }}
              />
            )}
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default withSnackbar(HomePage);
